// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_28-2";
export var blackBorderOnHover = "_28-7";
export var cell = "_28-6";
export var cellContainer = "_28-3";
export var checked = "_28-8";
export var disabled = "_28-5";
export var featuredIconCellContainer = "_28-9";
export var featuredIconTextContainer = "_28-b";
export var featuredIconWrapper = "_28-a";
export var noBorder = "_28-c";
export var orangeSelectedRow = "_51-3";
export var overflowableText = "_28-0";
export var overflowableTextContainer = "_28-1";
export var row = "_1o-0";
export var rowCheckboxCell = "_28-4";
export var selectableTable = "_51-2";